import type { LPSettlementInstructionStatusEnum, SettlementInstructionDirectionEnum } from '@talos/kyoko';
import { HStack, Icon, Text, Tooltip } from '@talos/kyoko';
import { memo } from 'react';
import type { DefaultTheme } from 'styled-components';
import { getDetailedLPAssetStatus, getLPAssetStatusMapping } from '../utils/lpAssetStatusMapping';

interface LPInstructionStatusRendererProps {
  theme: DefaultTheme;
  status: LPSettlementInstructionStatusEnum;
  direction: SettlementInstructionDirectionEnum;
  errorText: string | null;
}

export const LPInstructionStatusRenderer = memo(
  ({ theme, status, direction, errorText }: LPInstructionStatusRendererProps) => {
    const detailedStatus = getDetailedLPAssetStatus(status, direction);

    // If no detailed status mapping, just show the raw status
    if (!detailedStatus) {
      return <Text>{status}</Text>;
    }

    const statusMapping = getLPAssetStatusMapping(detailedStatus, theme);

    if (!statusMapping) {
      return <Text>{status}</Text>;
    }

    return (
      <Tooltip tooltip={errorText}>
        <HStack gap="spacing4">
          <Icon icon={statusMapping.icon} size={16} color={statusMapping.color} />
          <Text>{detailedStatus}</Text>
        </HStack>
      </Tooltip>
    );
  }
);
